import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ProgressBarStepComponent } from './progress-bar-step/progress-bar-step.component';
import { ProgressBarComponent } from './progress-bar.component';

@NgModule({
	declarations: [
		ProgressBarComponent,
		ProgressBarStepComponent,
	],
	imports: [
		CommonModule,
	],
	exports: [
		ProgressBarComponent,
		ProgressBarStepComponent,
	],
})
export class ProgressBarModule { }
